/*
 * BadgeRole
 * @module components/Badges
 * @flow
 */

import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Badge } from '../';
import IconMerchant from '@/icons/ic-role-merchant.png';
import IconRetailer from '@/icons/ic-role-retailer.png';
import IconWholesaler from '@/icons/ic-role-wholesaler.png';

import messages from './messages';

export type BadgeRoleProps = {
  role: 'M' | 'R' | 'W',
  size?: number,
};

/**
 * BadgeRole React-component
 * @memberof components
 * @param {Object} props - properties
 * @param {string} [props.role] - user role
 * @param {string} [props.size] - size
 * @example <caption>Simple usage</caption>
 * <BadgeRole role="M" />
 * @returns {React.Node<*>} React-component
 */
export const BadgeRole = ({ role, size }: BadgeRoleProps) => {
  const roleIconsMap = {
    M: IconMerchant,
    R: IconRetailer,
    W: IconWholesaler,
  };

  return (
    <Badge
      icon={roleIconsMap[role]}
      size={size}
      testid="badgerole"
      tooltip={<FormattedMessage {...messages['role' + role]} />}
    />
  );
};
